import { useCallback, useEffect, useRef, useState } from "react";

export type SaveStatus = "idle" | "saving" | "saved" | "error";

export function useAutosaveState() {
  const resetStatusTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isAutosavePaused, setIsAutosavePaused] = useState(false);
  const [saveStatus, setSaveStatus] = useState<SaveStatus>("idle");

  useEffect(() => {
    return () => {
      if (resetStatusTimeoutRef.current) {
        clearTimeout(resetStatusTimeoutRef.current);
      }
    };
  }, []);

  const handleSaveStart = useCallback(() => {
    setSaveStatus("saving");
  }, []);

  const handleSaveComplete = useCallback(() => {
    setSaveStatus("saved");

    if (resetStatusTimeoutRef.current) {
      clearTimeout(resetStatusTimeoutRef.current);
    }

    resetStatusTimeoutRef.current = setTimeout(() => {
      setSaveStatus("idle");
      resetStatusTimeoutRef.current = null;
    }, 3000);
  }, []);

  const handleSaveError = useCallback(() => {
    if (resetStatusTimeoutRef.current) {
      clearTimeout(resetStatusTimeoutRef.current);
      resetStatusTimeoutRef.current = null;
    }
    setSaveStatus("error");
  }, []);

  return {
    isAutosavePaused,
    setIsAutosavePaused,
    saveStatus,
    handleSaveStart,
    handleSaveComplete,
    handleSaveError,
  };
}
